import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/store";
Vue.use(VueRouter);
const Dashboard = () => import("../modules/shared/components/layout.vue");
const Login = () => import("../modules/login/components/Login.vue");
const ForgotPassword = () =>
  import("../modules/login/components/ForgotPassword.vue");
const ChangePassword = () =>
  import("../modules/login/components/ChangePassword.vue");
const ResetPassword = () =>
  import("../modules/login/components/ResetPassword.vue");
const AccessDenied = () =>
  import("../modules/shared/components/AccessDenied.vue");
const NotFound = () => import("../modules/shared/components/NotFound.vue");

const Home = () => import("../modules/Home");
const WebsitePage = () => import("../modules/Website/WebsitePage.vue");
const HallEnquiries = () => import("../modules/Website/HallEnquiries.vue");
//Bills
const SuspendedBillList = () => import("../modules/Bills/Index.vue");
const SuspendedBillDetails = () =>
  import("../modules/Bills/SuspendbillDetails.vue");

//Dishes
const DishList = () =>
  import("../modules/Dishes/Components/DishListComponent.vue");

const DishAdd = () =>
  import("../modules/Dishes/Components/DishCreateComponent.vue");

const DishEdit = () =>
  import("../modules/Dishes/Components/DishEditComponent.vue");

const DishDetails = () =>
  import("../modules/Dishes/Components/DishDetailsComponent.vue");

//Bookings
const BookList = () => import("../modules/Bookings/Components/BookingList.vue");
//MasterData

const MasterData = () =>
  import("../modules/MasterData/Components/MasterListComponent.vue");

//Guests
const GuestList = () => import("../modules/guests/Components/GuestList.vue");

const GuestEdit = () => import("../modules/guests/Components/GuestEdit.vue");

const GuestCreate = () =>
  import("../modules/guests/Components/GuestCreate.vue");

const GuestDetails = () =>
  import("../modules/guests/Components/GuestDetails.vue");

const FoodCategory = () =>
  import("../modules/FoodCategory/Component/FoodCategoryList.vue");
const Amenties = () => import("../modules/Amenties/components/Amenties.vue");
const Places = () => import("../modules/Places/Components/place.vue");
const Ingredients = () =>
  import(
    "../modules/MasterData/Components/Incredients/IncredientComponent.vue"
  );
const Waiter = () => import("../modules/Waiter/components/WaiterList.vue");
const Waiteradd = () => import("../modules/Waiter/components/WaiterCreate.vue");
const WaiterEdit = () => import("../modules/Waiter/components/WaiterEdit.vue");
const WaiterDetails = () =>
  import("../modules/Waiter/components/WaiterDetails.vue");
const Floor = () => import("../modules/Floor/Components/Floor.vue");
const KitchenStocks = () =>
  import("../modules/KitchenStocks/Components/KitchenStocksComponent.vue");
const Kitchens = () => import("../modules/Kitchens/Components/kitchen.vue");

//user Components
const UserList = () => import("../modules/user/components/UserList.vue");
const UserAdd = () => import("../modules/user/components/UserCreate.vue");
const UserEdit = () => import("../modules/user/components/UserEdit.vue");
const UserView = () => import("../modules/user/components/UserDetails.vue");

//role Components
const RoleList = () => import("../modules/role/RoleList.vue");
const AuditLog = () => import("../modules/AuditLog/AuditLog.vue");
const RoleAdd = () => import("../modules/role/RoleCreate.vue");
const RoleEdit = () => import("../modules/role/RoleEdit.vue");
const RoleView = () => import("../modules/role/RoleDetails.vue");

//Supplier Components
const SupplierAdd = () =>
  import("../modules/supplier/components/SupplierCreate.vue");
const SupplierEdit = () =>
  import("../modules/supplier/components/SupplierEdit.vue");
const SupplierList = () =>
  import("../modules/supplier/components/SupplierList.vue");
const SupplierDetails = () =>
  import("../modules/supplier/components/SupplierDetails.vue");

//Product Components
const ProductAdd = () =>
  import("../modules/Product/components/ProductCreate.vue");
const ProductEdit = () =>
  import("../modules/Product/components/ProductEdit.vue");
const ProductList = () =>
  import("../modules/Product/components/ProductList.vue");
const ProductView = () =>
  import("../modules/Product/components/ProductDetails.vue");
const ProductBatchView = () =>
  import("../modules/Product/components/ProductBatchView");

//PurchaseOrder Components
const PurchaseOrderAdd = () =>
  import("../modules/Purchase-Order/components/PurchaseOrderCreate.vue");
const PurchaseOrderEdit = () =>
  import("../modules/Purchase-Order/components/PurchaseOrderEdit.vue");
const PurchaseOrderList = () =>
  import("../modules/Purchase-Order/components/PurchaseOrderList.vue");
const PurchaseOrderView = () =>
  import("../modules/Purchase-Order/components/PurchaseOrderDetails.vue");

//Purchases
const PurchaseAdd = () =>
  import("../modules//Purchases/components/PurchaseCreate.vue");
const PurchaseList = () =>
  import("../modules//Purchases/components/PurchaseList.vue");
const PurchaseEdit = () =>
  import("../modules//Purchases/components/PurchaseEdit.vue");
const PurchaseView = () =>
  import("../modules//Purchases/components/PurchaseDetails.vue");

//Purchase Return
const PurchaseAddReturn = () =>
  import("../modules/purchase_return/components/PurchaseReturnCreate.vue");
const PurchaseReturnEdit = () =>
  import("../modules/purchase_return/components/PurchaseReturnEdit.vue");
const PurchaseReturnList = () =>
  import("../modules/purchase_return/components/PurchaseReturnList.vue");
const PurchaseReturnView = () =>
  import("../modules/purchase_return/components/PurchaseReturnDetails.vue");

//Room Type Component
const RateTypeList = () =>
  import("../modules/RateTypes/components/RateTypeList.vue");
const RateTypeAdd = () =>
  import("../modules/RateTypes/components/RateTypeCreate.vue");
const RateTypeEdit = () =>
  import("../modules/RateTypes/components/RateTypeEdit.vue");
const RateTypeView = () =>
  import("../modules/RateTypes/components/RateTypeDetails.vue");

//SettingComponents
const CategoryListComponent = () =>
  import(
    "../modules/shared/settings/productCategory/components/CategoryList.vue"
  );

const ExpenseCategoryList = () =>
  import(
    "../modules/shared/settings/ExpenseCategory/components/ExpenseCategoryList"
  );

const BedType = () => import("../modules/bedType/components/BedTypeList");
//change Password

const ChangePasswordComponent = () =>
  import(
    "../modules/shared/settings/ChangePassword/components/ChangePasswordComponent.vue"
  );

//shop component
const ShopComponentCreate = () =>
  import("../modules/shared/settings/Shop/components/CreateShopComonent.vue");
const ShopComponentEdit = () =>
  import("../modules/shared/settings/Shop/components/EditShopComponent.vue");
const ShopComponent = () =>
  import("../modules/shared/settings/Shop/components/ShopComponent.vue");
const ShopComponentDetails = () =>
  import("../modules/shared/settings/Shop/components/ShopDetailsComponent.vue");

const CategoryListViewComponent = () =>
  import(
    "../modules/shared/settings/productCategory/components/CategoryDetails.vue"
  );
const AccountList = () => import("../modules/Accounts/AccountsList");

//warehouse Comonents
const Warehouse = () =>
  import("../modules/shared/settings/Warehouse/components/WareHouseList.vue");

const WarehouseView = () =>
  import(
    "../modules/shared/settings/Warehouse/components/WarehouseDetails.vue"
  );

//Setting Component
const PosSetting = () =>
  import(
    "../modules/shared/settings/posSetting/components/PosSettingComponent.vue"
  );
const SiteSetting = () =>
  import(
    "../modules/shared/settings/siteSetting/components/SiteSettingComponent.vue"
  );
const KotSetting = () =>
  import(
    "../modules/shared/settings/kotSetting/components/KotSettingComponent.vue"
  );

//Meta Data
const Brand = () =>
  import("../modules/shared/settings/brand/BrandListComponent.vue");

const Unit = () =>
  import("../modules/shared/settings/Units/components/UnitList.vue");

// Reports Component
const SalesReports = () =>
  import("../modules/Reports/SalesReportComponent.vue");
const ProductReports = () =>
  import("../modules/Reports/ProductReportComponent.vue");
const ProductAllReport = () =>
  import("../modules/Reports/ProduttAllReport.vue");

const SummaryAllReport = () => import("../modules/Reports/Summary.vue");
const ExpiredProducts = () => import("../modules/Reports/ExpiredProducts.vue");
const DamagedProducts = () => import("../modules/Reports/DamageProducts.vue");
const PurchaseReturnReports = () =>
  import("../modules/Reports/PurchaseReturnReportComponent.vue");
const PurchaseReports = () =>
  import("../modules/Reports/PurchaseReportComponent.vue");
const PurchaseOrderReports = () =>
  import("../modules/Reports/PurchaseOrderReportComponent.vue");
const OutofStockReportComponent = () =>
  import("../modules/Reports/OutofStockReportComponent.vue");
const LowStockReportComponent = () =>
  import("../modules/Reports/LowStockReportComponent.vue");

const KitchenStocksReport = () =>
  import("../modules/Reports/KitchenStocksReport.vue");

const OrderReport = () => import("../modules/Reports/OrderReport.vue");

const ReservationReport = () =>
  import("../modules/Reports/ReservationReport.vue");

const OrderFoodProductReport = () =>
  import("../modules/Reports/OrderFoodProductReport.vue");
const AccountingReport = () =>
  import("../modules/Reports/AccountingReport.vue");

//Discount Component
const DiscountCreateComponent = () =>
  import("../modules/Discount/Discount.vue");
const DiscountDetailsComponent = () =>
  import("../modules/Discount/DiscountDetails.vue");
const DiscountListComponent = () =>
  import("../modules/Discount/DiscountList.vue");

//Stock Coponents
const StockList = () => import("../modules/Stocks/components/StockList.vue");
const StockTransferAdd = () =>
  import("../modules/Stocks/components/StockTransferCreate.vue");
const StockTransferList = () =>
  import("../modules/Stocks/components/StockTransferList.vue");
const StockTransferDetails = () =>
  import("../modules/Stocks/components/StockTrasferDetails.vue");

const StockTransferEdit = () =>
  import("../modules/Stocks/components/StockTransferEdit.vue");

//ketchen transfer Coponents
const KitchenTransferList = () =>
  import("../modules/KitchenTransfers/KitchenTransferList.vue");

const KitchenCreate = () =>
  import("../modules/KitchenTransfers/KitchenTransferCreate.vue");

//Sales Component
const SalesList = () => import("../modules/Sales/SalesList.vue");

const SalesDetails = () => import("../modules/Sales/SalesDetails.vue");

const PurchasePaymentView = () =>
  import("../modules//Purchases/components/PurchasePaymentView.vue");

const ChequeList = () => import("../modules/ChequeManagement/ChequeList.vue");

const ExpensesList = () => import("../modules/Expenses/components/ExpenseList");
const IncomesList = () => import("../modules/Incomes/components/IncomeList");
const AccountingDashboard = () => import("../modules/Accounting/AccountingDashboard");

const Organization = () =>
  import("../modules/shared/settings/Organization/OrganizationComponent.vue");
const PaymentList = () => import("../modules/Payment/components/PaymentList");
const PaymentView = () => import("../modules/Payment/components/PaymentView");

const ShopStockList = () => import("../modules/ShopStock/ShopStockList.vue");

// Room Component
const RoomAdd = () => import("../modules/Room/components/RoomCreate.vue");
const RoomEdit = () => import("../modules/Room/components/RoomEdit.vue");
const RoomList = () => import("../modules/Room/components/RoomList.vue");
const RoomView = () => import("../modules/Room/components/RoomDetails.vue");
const ReservationList = () =>
  import("../modules/Room/components/ReservationList.vue");
const ReservationDetails = () =>
  import("../modules/Room/components/ReservationDetails.vue");

//Room Type Component
const RoomTypeList = () =>
  import("../modules/RoomTypes/components/RoomTypeList.vue");
const RoomTypeAdd = () =>
  import("../modules/RoomTypes/components/RoomTypeCreate.vue");
const RoomTypeEdit = () =>
  import("../modules/RoomTypes/components/RoomTypeEdit.vue");
const RoomTypeView = () =>
  import("../modules/RoomTypes/components/RoomTypeDetails.vue");

const TableList = () =>
  import("../modules/MasterData/Components/Table/components/TableList.vue");
// const RoomTypeAdd = () =>
//   import("../modules/RoomTypes/components/RoomTypeCreate.vue");
// const RoomTypeEdit = () =>
//   import("../modules/RoomTypes/components/RoomTypeEdit.vue");
// const RoomTypeView = () =>
//   import("../modules/RoomTypes/components/RoomTypeDetails.vue");
//Tables Component
const routes = configRoutes();
const router = new VueRouter({
  linkActiveClass: "active",
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
////Stocks////

// router.beforeEach((to, from, next) => {
//   app.loading = true;
//   next();
// });

// router.afterEach(() => {
//   setTimeout(() => (app.loading = false), 1500); // timeout for demo purposes
// });

const PUBLIC_PATHS = [
  "/login",
  "/forgot-password",
  "/reset-password",
  "/reset_password",
  "/notFound",
  "/accessDenied",
];

function isPublicRoute(to) {
  return PUBLIC_PATHS.some(
    (path) => to.path === path || to.path.startsWith(path + "/")
  );
}

function policyName(permission) {
  if (!permission) return null;
  if (typeof permission === "string") return permission;
  return permission.name || null;
}

function getUserPermissions() {
  const fromStore =
    (store.state.user && store.state.user.policies) || [];
  if (fromStore.length) return fromStore;
  try {
    const stored = JSON.parse(localStorage.getItem("user") || "null");
    if (
      stored &&
      Array.isArray(stored.permissions) &&
      stored.permissions.length
    ) {
      return stored.permissions;
    }
  } catch (e) {
    // ignore invalid localStorage
  }
  return [];
}

function hasAnyRequiredPermission(permissions, metaPerm) {
  if (!metaPerm) return true;
  if (metaPerm === "Dashboard") return true;
  const required = Array.isArray(metaPerm) ? metaPerm : [metaPerm];
  if (!permissions || !permissions.length) return false;
  return permissions.some((p) => {
    const name = policyName(p);
    return name && required.includes(name);
  });
}

function isAuthenticated() {
  return Boolean(localStorage.getItem("token") || localStorage.getItem("user"));
}

function checkPermission(to, from, next) {
  if (isPublicRoute(to)) {
    if (to.path === "/login" && isAuthenticated()) {
      return next({ name: "DashboardHome", replace: true });
    }
    return next();
  }

  if (!isAuthenticated()) {
    return next("/login");
  }

  if (to.path === "/cheque" || to.path.indexOf("/cheque/") === 0) {
    const settings = store.state.sitesetting && store.state.sitesetting.siteSettings;
    const enabled = settings && settings.cheque_enabled;
    if (settings && enabled === false) {
      return next({ name: "DashboardHome", replace: true });
    }
  }

  if (
    to.name === "DashboardHome" ||
    to.matched.some((record) => record.name === "DashboardHome")
  ) {
    return next();
  }

  const permissions = getUserPermissions();
  const metaPerm = to.matched.length
    ? to.matched[to.matched.length - 1].meta.permission
    : to.meta && to.meta.permission;

  if (!metaPerm || hasAnyRequiredPermission(permissions, metaPerm)) {
    return next();
  }

  if (to.path === "/notFound") {
    return next();
  }

  return next("/notFound");
}

router.beforeEach((to, from, next) => {
  checkPermission(to, from, next);
});

function configRoutes() {
  return [
    {
      path: "/accessDenied",
      name: "AccessDenied",
      component: AccessDenied,
    },
    {
      path: "/notFound",
      name: "notFound",
      component: NotFound,
    },
    {
      path: "/login",
      name: "Home",
      component: Login,
    },

    {
      path: "/reset-password",
      name: "Reset Password",
      component: ResetPassword,
      children: [
        {
          path: "/reset_password",
          name: "resetPassword",
          component: ResetPassword,
          props: (route) => ({ query: [route.query.token] }),
        },
      ],
    },
    {
      path: "/forgot-password",
      name: "Forget Password",
      component: ForgotPassword,
    },
    {
      path: "/change-password",
      name: "Change Password",
      component: ChangePassword,
    },

    {
      path: "/",
      name: "Dashboard",
      component: Dashboard,
      redirect: { name: "DashboardHome" },
      children: [
        {
          path: "",
          name: "DashboardHome",
          component: Home,
          meta: {
            permission: ["Dashboard Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
            ],
          },
        },
        {
          path: "/user",
          name: "Dashboard",
          component: UserList,
          meta: {
            permission: ["User Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Users",
                disabled: false,
                to: "/user",
                exact: true,
              },
            ],
          },
        },

        {
          path: "user/edit/:id",
          name: "User",
          component: UserEdit,
          meta: {
            permission: ["User Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Users",
                disabled: false,
                to: "/user",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: (route) => `user/${route.param}`,
                exact: true,
              },
            ],
          },
        },
        {
          path: "user/add",
          name: "User",
          component: UserAdd,
          meta: {
            permission: ["User Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Users",
                disabled: false,
                to: "/user",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/user/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: "user/:id",
          name: "viewUser",
          component: UserView,
          meta: {
            permission: ["User Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Users",
                disabled: false,
                to: "/user",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: (route) => `user/${route.param}`,
                exact: true,
              },
            ],
          },
        },

        {
          path: "audit-log",
          name: "AuditLog",
          component: AuditLog,
          meta: {
            permission: ["Audit Log Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Audit Log",
                disabled: true,
                to: "/audit-log",
                exact: true,
              },
            ],
          },
        },
        {
          path: "role",
          name: "Dashboard",
          component: RoleList,
          meta: {
            permission: ["Role Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Roles",
                disabled: false,
                to: "/role",
                exact: true,
              },
            ],
          },
        },
        {
          path: "role/create",
          name: "Add Role",
          component: RoleAdd,
          meta: {
            permission: ["Role Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Roles",
                disabled: false,
                to: "/role",
                exact: true,
              },
              {
                text: "Create",
                disabled: true,
                to: "/role/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: "role/edit/:id",
          name: "Edit",
          component: RoleEdit,
          props: true,
          meta: {
            permission: ["Role Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Roles",
                disabled: false,
                to: "/role",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: (route) => `role/${route.param}`,
                exact: true,
              },
              // {
              //   text: "Edit",
              //   disabled: true,
              //   to: "Edit",
              //   exact: true,
              // },
            ],
          },
        },
        {
          path: "role/:id",
          name: "View",
          component: RoleView,
          props: true,
          meta: {
            permission: ["Role Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Roles",
                disabled: false,
                to: "/role",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: (route) => `role/${route.param}`,
                exact: true,
              },
              // {
              //   text: "View",
              //   disabled: true,
              //   to: "View",
              //   exact: true,
              // },
            ],
          },
        },
      ],
    },

    {
      path: "/sales",
      name: "Sales",
      component: Dashboard,
      children: [
        {
          path: "/sales",
          name: "SalesList",
          component: SalesList,
          meta: {
            permission: ["Sales Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Sales",
                disabled: false,
                to: "/sales",
                exact: true,
              },
            ],
          },
        },
        {
          path: "view/:id",
          name: "ViewSales",
          component: SalesDetails,
          meta: {
            permission: ["Sales Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Sales",
                disabled: false,
                to: "/sales",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "View",
              //   disabled: true,
              // },
            ],
          },
        },
      ],
    },

    {
      path: "/supplier",
      name: "Supplier",
      component: Dashboard,
      children: [
        {
          path: "/supplier",
          name: "SupplierList",
          component: SupplierList,
          meta: {
            permission: ["Supplier Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Suppliers",
                disabled: false,
                to: "/supplier",
                exact: true,
              },
            ],
          },
        },

        {
          path: "add",
          name: "AddSupplier",
          component: SupplierAdd,
          meta: {
            permission: ["Supplier Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Suppliers",
                disabled: false,
                to: "/supplier",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/supplier/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: "edit/:id",
          name: "EditSupplier",
          component: SupplierEdit,
          meta: {
            permission: ["Supplier Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Suppliers",
                disabled: false,
                to: "/supplier",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "Edit",
              //   disabled: true,
              //   to: "",
              //   exact: true,
              // },
            ],
          },
        },
        ,
        {
          path: ":id",
          name: "ViewSupplier",
          component: SupplierDetails,
          meta: {
            permission: ["Supplier Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Suppliers",
                disabled: false,
                to: "/supplier",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "View",
              //   disabled: true,
              // },
            ],
          },
        },
      ],
    },

    {
      path: "/accounts",
      name: "Account",
      component: Dashboard,
      children: [
        {
          path: "/accounts",
          name: "AccountsDetails",
          component: AccountList,
          meta: {
            permission: ["Supplier Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Accounts",
                disabled: false,
                to: "/accounts",
                exact: true,
              },
            ],
          },
        },

        {
          path: "add",
          name: "AddSupplier",
          component: SupplierAdd,
          meta: {
            permission: ["Supplier Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Supplier",
                disabled: false,
                to: "/supplier",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: "edit/:id",
          name: "EditSupplier",
          component: SupplierEdit,
          meta: {
            permission: ["Supplier Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Supplier",
                disabled: false,
                to: "/supplier",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "Edit",
              //   disabled: false,
              //   to: "",
              //   exact: true,
              // },
            ],
          },
        },
      ],
    },
    {
      path: "/kitchen-transfer/",
      name: "kitchen",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "kitchen",
          component: KitchenTransferList,
          meta: {
            permission: ["Kitchen Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "kitchens",
                disabled: false,
                to: "/kitchen-transfer",
                exact: true,
              },
            ],
          },
        },
        {
          path: "add",
          name: "AddKitchen",
          component: KitchenCreate,
          meta: {
            permission: ["Kitchen Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Products",
                disabled: false,
                to: "/kitchen-transfer",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/kitchen-transfer/add",
                exact: true,
              },
            ],
          },
        },

        // {
        //   path: ":id",
        //   name: "View",
        //   component: ProductView,
        //   beforeEnter: (to, from, next) => {
        //     checkPermission(to, from, next);
        //   },
        //   meta: {
        //     permission: ["Product Show"],
        //     breadcrumb: [
        //       {
        //         text: "Dashboard",
        //         disabled: false,
        //         to: "/",
        //         exact: true,
        //       },
        //       {
        //         text: "Products",
        //         disabled: false,
        //         to: "/product",
        //         exact: true,
        //       },
        //       {
        //         text: ":id",
        //         disabled: false,
        //         to: (route) => `${route.param}`,
        //         exact: true,
        //       },
        //       {
        //         text: "View",
        //         disabled: false,
        //         exact: true,
        //       },
        //     ],
        //   },
        // },
        // {
        //   path: "edit/:id",
        //   name: "Edit",
        //   component: ProductEdit,
        //   beforeEnter: (to, from, next) => {
        //     checkPermission(to, from, next);
        //   },
        //   meta: {
        //     permission: ["Product Edit"],
        //     breadcrumb: [
        //       {
        //         text: "Dashboard",
        //         disabled: false,
        //         to: "/",
        //         exact: true,
        //       },
        //       {
        //         text: "Products",
        //         disabled: false,
        //         to: "/product",
        //         exact: true,
        //       },
        //       {
        //         text: ":id",
        //         disabled: false,
        //         to: (route) => `product/${route.param}`,
        //         exact: true,
        //       },
        //       {
        //         text: "Edit",
        //         disabled: true,
        //         to: "Edit",
        //         exact: true,
        //       },
        //     ],
        //   },
        // },
      ],
    },

    {
      path: "/product/",
      name: "Product",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "Product",
          component: ProductList,
          meta: {
            permission: ["Product Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Products",
                disabled: false,
                to: "/product",
                exact: true,
              },
            ],
          },
        },
        {
          path: "add",
          name: "AddProduct",
          component: ProductAdd,
          meta: {
            permission: ["Product Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Products",
                disabled: false,
                to: "/product",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/product/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: ":id",
          name: "View",
          component: ProductView,
          meta: {
            permission: ["Product Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Products",
                disabled: false,
                to: "/product",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "View",
              //   disabled: false,
              //   exact: true,
              // },
            ],
          },
        },
        {
          path: ":id/batch/:batch_id",
          name: "Batch",
          component: ProductBatchView,

          meta: {
            permission: ["Batch Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Products",
                disabled: false,
                to: "/product",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `${route.param.id}`,
                exact: true,
              },
              {
                text: "Batches",
                disabled: false,
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `${route.param.id}`,
                exact: true,
              },
            ],
          },
        },
        {
          path: "edit/:id",
          name: "Edit",
          component: ProductEdit,
          meta: {
            permission: ["Product Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Products",
                disabled: false,
                to: "/product",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `product/${route.param}`,
                exact: true,
              },
              // {
              //   text: "Edit",
              //   disabled: true,
              //   to: "Edit",
              //   exact: true,
              // },
            ],
          },
        },
      ],
    },
    {
      path: "/purchase-order",
      name: "PurchaseOrder",
      component: Dashboard,

      children: [
        {
          path: "add",
          name: "AddPurchaseOrder",
          component: PurchaseOrderAdd,
          meta: {
            permission: ["Purchase Order Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              // {
              //   text: "Purchases",
              //   disabled: true,
              //   to: "/",
              //   exact: true,
              // },
              {
                text: "Purchase Orders",
                disabled: false,
                to: "/purchase-order",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/purchase-order/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: "",
          name: "ListPurchaseOrder",
          component: PurchaseOrderList,
          meta: {
            permission: ["Purchase Order Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              // {
              //   text: "Purchases Orders",
              //   disabled: true,
              //   to: "/",
              //   exact: true,
              // },
              {
                text: "Purchase Orders",
                disabled: false,
                to: "/purchase-order",
                exact: true,
              },
            ],
          },
        },
        {
          path: "edit/:id",
          name: "EditPurchaseOrder",
          component: PurchaseOrderEdit,
          meta: {
            permission: ["Purchase Order Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Purchase Orders",
                disabled: false,
                to: "/purchase-order",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "Edit",
              //   disabled: true,
              //   to: "/purchase-order",
              //   exact: true,
              // },
            ],
          },
        },
        {
          path: ":id",
          name: "View",
          component: PurchaseOrderView,
          meta: {
            permission: ["Purchase Order Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Purchase Orders",
                disabled: false,
                to: "/purchase-order",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "View",
              //   disabled: true,
              //   to: "/purchase-order/:id",
              //   exact: true,
              // },
            ],
          },
        },
      ],
    },

    {
      path: "/masterdata",
      name: "MasterData",
      component: Dashboard,
      children: [
        {
          path: "category",
          name: "categoryList",
          component: CategoryListComponent,
          meta: {
            permission: ["Category Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Master Data",
                disabled: true,
                // to: "/",
                exact: true,
              },
              {
                text: "Category",
                disabled: false,
                to: "/masterdata/category",
                exact: true,
              },
            ],
          },
        },
        {
          path: "category/:id",
          name: "categoryView",
          component: CategoryListViewComponent,
          meta: {
            permission: ["Category Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Master Data",
                disabled: true,
                // to: "/",
                exact: true,
              },
              {
                text: "Category",
                disabled: false,
                to: "/masterdata/category",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `${route.param}`,
                exact: true,
              },
            ],
          },
        },
        {
          path: "unit",
          name: "Unit",
          component: Unit,
          meta: {
            permission: ["Unit Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
              },
              {
                text: "Master Data",
                disabled: true,
                // to: "/",
              },
              {
                text: "Unit",
                disabled: false,
                to: "/masterdata/unit",
              },
            ],
          },
        },
        {
          path: "brand",
          name: "BRAND",
          component: Brand,
          meta: {
            permission: ["Brand Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
              },
              {
                text: "MasterData",
                disabled: true,
              },
              {
                text: "Brand",
                disabled: false,
                to: "/masterdata/brand",
              },
            ],
          },
        },
        {
          path: "expense-category",
          name: "Expense Category List",
          component: ExpenseCategoryList,
          meta: {
            permission: ["Expense Category Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Master Data",
                disabled: true,
                // to: "/",
                exact: true,
              },
              {
                text: "Expense Category",
                disabled: true,
                exact: true,
              },
            ],
          },
        },
      ],
    },

    {
      path: "/website",
      component: Dashboard,
      children: [
        {
          path: "rooms",
          name: "WebsiteRooms",
          component: WebsitePage,
          meta: { section: "rooms", permission: ["Website Rooms Index"] },
        },
        {
          path: "hall",
          name: "WebsiteHall",
          component: WebsitePage,
          meta: { section: "hall", permission: ["Website Banquet Hall Index"] },
        },
        {
          path: "hall-enquiries",
          name: "WebsiteHallEnquiries",
          component: HallEnquiries,
          meta: { permission: ["Website Banquet Hall Index"] },
        },
        {
          path: "restaurant",
          name: "WebsiteRestaurant",
          component: WebsitePage,
          meta: { section: "restaurant", permission: ["Website Restaurant Index"] },
        },
        {
          path: "about",
          name: "WebsiteAbout",
          component: WebsitePage,
          meta: { section: "about", permission: ["Website About Index"] },
        },
        {
          path: "contact",
          name: "WebsiteContact",
          component: WebsitePage,
          meta: { section: "contact", permission: ["Website Contact Index"] },
        },
      ],
    },
    {
      path: "/setting",
      name: "setting",
      component: Dashboard,
      children: [
        // {
        //   path: "kot",
        //   name: "KOT Setting",
        //   component: PosSetting,
        //   beforeEnter: (to, from, next) => {
        //     checkPermission(to, from, next);
        //   },
        //   meta: {
        //     permission: ["Pos setting Index"],
        //     breadcrumb: [
        //       {
        //         text: "Dashboard",
        //         disabled: false,
        //         to: "/",
        //       },
        //       {
        //         text: "Settings",
        //         disabled: true,
        //         // to: "/",
        //       },
        //       {
        //         text: "Pos Settings",
        //         disabled: true,
        //         //to: "/setting/warehouse",
        //       },
        //     ],
        //   },
        // },
        {
          path: "kot",
          name: "KOT Setting",
          component: KotSetting,
          meta: {
            permission: ["Kot setting Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
              },

              {
                text: "Kot Settings",
                disabled: true,
                //to: "/setting/warehouse",
              },
            ],
          },
        },

        {
          path: "organization",
          name: "Organization",
          component: Organization,
          meta: {
            permission: ["Organization Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
              },

              {
                text: "Organization",
                disabled: true,
                //to: "/setting/warehouse",
              },
            ],
          },
        },

        {
          path: "sites",
          name: "SiteSetting",
          component: SiteSetting,
          meta: {
            permission: ["Site setting Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
              },

              {
                text: "Site Configuration",
                disabled: true,
                //to: "/setting/warehouse",
              },
            ],
          },
        },
      ],
    },
    {
      path: "/purchase",
      name: "purchases",
      component: Dashboard,
      children: [
        {
          path: "add",
          name: "AddPurchase",
          component: PurchaseAdd,
          meta: {
            permission: ["Purchase Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Purchases",
                disabled: false,
                to: "/purchase",
                exact: true,
              },
              // {
              //   text: "Purchases",
              //   disabled: false,
              //   to: "/purchase",
              //   exact: true,
              // },
              {
                text: "Create",
                disabled: true,
                to: "/purchase/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: "/changepassword",
          name: "ChangePassword",
          component: ChangePasswordComponent,
          meta: {
            permission: ["Purchase Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "ChangePassword",
                disabled: false,

                exact: true,
              },
            ],
          },
        },
        {
          path: "/warehouse",
          name: "warehouse",
          component: Warehouse,
          meta: {
            permission: ["Ware House Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Warehouses",
                disabled: false,
                to: "/warehouse",
                exact: true,
              },
            ],
          },
        },
        {
          path: "/warehouse/:id",
          name: "warehouse",
          component: WarehouseView,
          meta: {
            permission: ["Ware House Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Warehouses",
                disabled: false,
                to: "/warehouse",
                exact: true,
              },

              {
                text: ":id",
                disabled: false,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "view",
              //   disabled: false,
              //   to: "/warehouse/:id",
              //   exact: true,
              // },
            ],
          },
        },

        {
          path: "/shop/add",
          name: "Create shop",
          component: ShopComponentCreate,
          meta: {
            permission: ["Shop Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
              },

              {
                text: "Shops",
                disabled: false,
                to: "/shop",
                exact: true,
              },
              {
                text: "create",
                disabled: false,
                to: "/shop/add",
              },
            ],
          },
        },

        {
          path: "/shop/edit/:id",
          name: "EditShop",
          component: ShopComponentEdit,
          meta: {
            permission: ["Shop Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Shops",
                disabled: false,
                to: "/shop",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "edit",
              //   disabled: true,
              //   to: "edit/:id",
              //   exact: true,
              // },
            ],
          },
        },
        {
          path: "/shop/:id",
          name: "View",
          component: ShopComponentDetails,
          meta: {
            permission: ["Shop Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Shops",
                disabled: false,
                to: "/product",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "View",
              //   disabled: true,
              //   to: "shop/:id",
              //   exact: true,
              // },
            ],
          },
        },

        {
          path: "/shop",
          name: "shop",
          component: ShopComponent,

          meta: {
            permission: ["Shop Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
              },

              {
                text: "Shop",
                disabled: false,
              },
            ],
          },
        },
        {
          path: "/bed-types",
          name: "bedtype",
          component: BedType,

          meta: {
            permission: ["Bed Type Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
              },

              {
                text: "Bed Types",
                disabled: false,
              },
            ],
          },
        },
        {
          path: "",
          name: "PurchaseList",
          component: PurchaseList,
          meta: {
            permission: ["Purchase Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              // {
              //   text: "Purchases",
              //   disabled: true,
              //   to: "/",
              //   exact: true,
              // },
              {
                text: "Purchases",
                disabled: false,
                to: "/purchase",
                exact: true,
              },
            ],
          },
        },
        {
          path: "edit/:id",
          name: "Edit",
          component: PurchaseEdit,
          meta: {
            permission: ["Purchase Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              // {
              //   text: "Purchases",
              //   disabled: true,
              //   to: "/",
              //   exact: true,
              // },
              {
                text: "Purchases",
                disabled: false,
                to: "/purchase",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "edit",
              //   disabled: true,
              //   to: "/edit/:id",
              //   exact: true,
              // },
            ],
          },
        },
        {
          path: ":id",
          name: "View",
          component: PurchaseView,
          meta: {
            permission: ["Purchase Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              // {
              //   text: "Purchases",
              //   disabled: true,
              //   to: "/",
              //   exact: true,
              // },
              {
                text: "Purchases",
                disabled: false,
                to: "/purchase",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "View",
              //   disabled: true,
              //   to: "/purchase/:id",
              //   exact: true,
              // },
            ],
          },
        },
        {
          path: ":id/payment/:paymentId",
          name: "Edit",
          component: PurchasePaymentView,
          // beforeEnter: (to, from, next) => {
          //   checkPermission(to, from, next);
          // },
          meta: {
            //permission: ["Purchase Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Purchase",
                disabled: false,
                to: "/purchase",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `${route.param}`,
                exact: true,
              },
              {
                text: "payment",
                disabled: false,
                to: "/payment",
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/purchase-return",
      name: "Purchase Return",
      component: Dashboard,
      children: [
        {
          path: "add",
          name: "AddPurchaseOrder",
          component: PurchaseAddReturn,
          meta: {
            permission: ["Purchase Return Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Purchase Returns",
                disabled: false,
                to: "/purchase-return",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/purchase-return/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: "edit/:id",
          name: "Edit",
          component: PurchaseReturnEdit,
          meta: {
            permission: ["Purchase Return Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Purchase Returns",
                disabled: false,
                to: "/purchase-return",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: "/purchase-return",
                exact: true,
              },
              // {
              //   text: "Edit",
              //   disabled: true,
              //   to: "/purchase-return/edit/:id",
              //   exact: true,
              // },
            ],
          },
        },
        {
          path: "",
          name: "Edit",
          component: PurchaseReturnList,
          meta: {
            permission: ["Purchase Return Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Purchase Returns",
                disabled: false,
                to: "/purchase-return",
                exact: true,
              },
            ],
          },
        },
        {
          path: ":id",
          name: "View",
          component: PurchaseReturnView,
          meta: {
            permission: ["Purchase Return Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Purchase Returns",
                disabled: false,
                to: "/purchase-return",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "View",
              //   disabled: false,
              //   to: "/purchase-return/1",
              //   exact: true,
              // },
            ],
          },
        },
      ],
    },
    {
      path: "/setting",
      name: "setting",
      component: Dashboard,
      children: [],
    },

    {
      path: "/das",
      name: "Stock",
      component: Dashboard,
      children: [
        {
          path: "/stock",
          name: "Stock",
          component: StockList,
          meta: {
            permission: ["Stocks Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Stocks",
                disabled: true,
                to: "/",
                exact: true,
              },
              // {
              //   text: "Warehouse",
              //   disabled: false,
              //   to: "/stock",
              //   exact: true,
              // },
            ],
          },
        },
        {
          path: "/shop-stock",
          name: "Shop Stock",
          component: ShopStockList,
          meta: {
            permission: ["Stocks Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Stocks",
                disabled: true,
                to: "/",
                exact: true,
              },
              {
                text: "Shop",
                disabled: true,
                to: "/",
                exact: true,
              },
            ],
          },
        },
        {
          path: "/stock-transfer/add",
          name: "Stock",
          component: StockTransferAdd,
          meta: {
            permission: ["Transfer Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Stocks",
                disabled: true,
                to: "/",
                exact: true,
              },
              {
                text: "Stock Transfer",
                disabled: false,
                to: "/stock-transfer",
                exact: true,
              },
              {
                text: "create",
                disabled: false,
                to: "/stock-transfer/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: "/stock-transfer/edit/:id",
          name: "Stock",
          component: StockTransferEdit,
          meta: {
            permission: ["Transfer Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Stocks",
                disabled: true,
                to: "/",
                exact: true,
              },
              {
                text: "Stock Transfer",
                disabled: false,
                to: "/stock-transfer",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: "/stock-transfer",
                exact: true,
              },
              // {
              //   text: "edit",
              //   disabled: true,
              //   to: "/stock-transfer",
              //   exact: true,
              // },
            ],
          },
        },
        {
          path: "/stock-transfer",
          name: "Stock",
          component: StockTransferList,
          meta: {
            permission: ["Transfer Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Stocks",
                disabled: true,
                to: "/",
                exact: true,
              },
              {
                text: "Stock-Transfer",
                disabled: false,
                to: "/stock-transfer",
                exact: true,
              },
            ],
          },
        },
        {
          path: "/stock-transfer/:id",
          name: "Stock",
          component: StockTransferDetails,
          meta: {
            permission: ["Transfer Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Stocks",
                disabled: true,
                to: "/",
                exact: true,
              },
              {
                text: "Stock Transfer",
                disabled: false,
                to: "/stock-transfer",
                exact: true,
              },
              {
                text: ":id",
                disabled: true,
                to: "/stock/transfer",
                exact: true,
              },
              // {
              //   text: "view",
              //   disabled: true,
              //   to: "/stock/transfer",
              //   exact: true,
              // },
            ],
          },
        },

        {
          path: "add",
          name: "AddProduct",
          component: ProductAdd,
          meta: {
            permission: ["Product Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Products",
                disabled: false,
                to: "/product",
                exact: true,
              },

              {
                text: "create",
                disabled: false,
                to: "/stock/transfer/add",
                exact: true,
              },
            ],
          },
        },
      ],
    },
    // {
    //   path: "/bookings",
    //   name: "Bookings",
    //   component: Dashboard,
    //   beforeEnter: (to, from, next) => {
    //     checkPermission(to, from, next);
    //   },
    //   children: [
    //     {
    //       path: "/",
    //       name: "BookingList",
    //       component: BookList,
    //       meta: {
    //         permission: ["Customer Index"],
    //         breadcrumb: [
    //           {
    //             text: "Dashboard",
    //             disabled: false,
    //             to: "/",
    //             exact: true,
    //           },
    //           {
    //             text: "Bookings",
    //             disabled: false,
    //             to: "/bookings",
    //             exact: true,
    //           },
    //         ],
    //       },
    //     },

    //   ],
    // },

    {
      path: "/table",
      name: "Table",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "TableList",
          component: TableList,
          meta: {
            permission: ["Table Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Tables",
                disabled: false,
                to: "/table",
                exact: true,
              },
            ],
          },
        },
      ],
    },

    {
      path: "/dishes",
      name: "Dishes",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "DishesList",
          component: DishList,
          meta: {
            permission: ["Dish Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Dishes",
                disabled: false,
                to: "/dishes",
                exact: true,
              },
            ],
          },
        },
        {
          path: "edit/:id",
          name: "EditDishes",
          component: DishEdit,
          meta: {
            permission: ["Dish Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Dishes",
                disabled: false,
                to: "/dishes",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `dishes/${route.param}`,
                exact: true,
              },
            ],
          },
        },
        {
          path: "add",
          name: "CreateDishes",
          component: DishAdd,
          meta: {
            permission: ["Dish Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Dishes",
                disabled: false,
                to: "/dishes",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/dishes/add",
                exact: true,
              },
            ],
          },
        },

        {
          path: ":id",
          name: "Viewdishes",
          component: DishDetails,
          meta: {
            permission: ["Guest Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Dishes",
                disabled: false,
                to: "/dishes",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `dishes/${route.param}`,
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/suspended_bills",
      name: "SuspendBills",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "suspended_bills",
          component: SuspendedBillList,
          meta: {
            permission: ["Dish Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Order Bills",
                disabled: false,
                to: "/order_bills",
                exact: true,
              },
            ],
          },
        },
        {
          path: ":id",
          name: "suspended_bills",
          component: SuspendedBillDetails,
          meta: {
            permission: ["Dish Index"],
            breadcrumb: [
              {
                text: "Suspended Bill",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "SuspendedBills",
                disabled: false,
                to: "/suspended_bills",
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/master-data",
      name: "MasterData",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "MasterData",
          component: MasterData,
          meta: {
            permission: ["Master Data Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "MasterData",
                disabled: false,
                to: "/master-data",
                exact: true,
              },
            ],
          },
        },
      ],
    },

    {
      path: "/guests",
      name: "Guests",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "GuestList",
          component: GuestList,
          meta: {
            permission: ["Guest Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Guests",
                disabled: false,
                to: "/guests",
                exact: true,
              },
            ],
          },
        },
        {
          path: "edit/:id",
          name: "EditGuests",
          component: GuestEdit,
          meta: {
            permission: ["Guest Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Guests",
                disabled: false,
                to: "/guests",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "edit",
              //   disabled: true,
              //   to: "edit/:id",
              //   exact: true,
              // },
            ],
          },
        },
        {
          path: "add",
          name: "CreateGuests",
          component: GuestCreate,
          meta: {
            permission: ["Guest Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Guests",
                disabled: false,
                to: "/guests",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/guests/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: ":id",
          name: "Viewguests",
          component: GuestDetails,
          meta: {
            permission: ["Guest Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Guests",
                disabled: false,
                to: "/guests",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "View",
              //   disabled: false,
              // },
            ],
          },
        },
      ],
    },
    {
      path: "/discount",
      name: "Discount",
      component: Dashboard,
      children: [
        {
          path: "add",
          name: "AddPurchase",
          component: DiscountCreateComponent,
          meta: {
            permission: ["Discount Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Discount",
                disabled: false,
                to: "/discount",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: "",
          name: "Discount",
          component: DiscountListComponent,
          meta: {
            permission: ["Discount Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Discount",
                disabled: false,
                to: "/discount",
                exact: true,
              },
            ],
          },
        },
        {
          path: "edit/:id",
          name: "Edit",
          component: DiscountCreateComponent,
          meta: {
            permission: ["Discount Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Discount",
                disabled: false,
                to: "/discount",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "edit",
              //   disabled: false,
              //   to: "/edit/:id",
              //   exact: true,
              // },
            ],
          },
        },
        {
          path: ":id",
          name: "View",
          component: DiscountDetailsComponent,
          meta: {
            permission: ["Discount Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Discount",
                disabled: false,
                to: "/discount",
                exact: true,
              },
              {
                text: "Details",
                disabled: false,
                to: (route) => `${route.param}`,
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/cheque/",
      name: "Cheque Management",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "Cheques",
          component: ChequeList,
          meta: {
            permission: ["Cheques Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Cheques",
                disabled: false,
                to: "/cheque",
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/accounting",
      name: "Accounting",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "Accounting Dashboard",
          component: AccountingDashboard,
          meta: {
            permission: ["Accounting Dashboard"],
            breadcrumb: [
              { text: "Dashboard", disabled: false, to: "/", exact: true },
              { text: "Accounting", disabled: false, to: "/accounting", exact: true },
            ],
          },
        },
      ],
    },
    {
      path: "/incomes/",
      name: "Incomes",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "Incomes",
          component: IncomesList,
          meta: {
            permission: ["Income Index"],
            breadcrumb: [
              { text: "Dashboard", disabled: false, to: "/", exact: true },
              { text: "Incomes", disabled: false, to: "/incomes", exact: true },
            ],
          },
        },
      ],
    },
    {
      path: "/expenses/",
      name: "Expenses",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "Expenses",
          component: ExpensesList,
          meta: {
            permission: ["Expense Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Expenses",
                disabled: false,
                to: "/expenses",
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/payment",
      name: "Payments ",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "Payments",
          component: PaymentList,
          meta: {
            permission: ["Payment Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Payments",
                disabled: false,
                to: "/payment",
                exact: true,
              },
            ],
          },
        },
        {
          path: "/payment/:id",
          name: "PaymentView",
          component: PaymentView,
          meta: {
            permission: ["Payment View"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Payments",
                disabled: false,
                to: "/payment",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: "/:id",
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/food-category/",
      name: "FoodCategory ",
      path: "/food-category/",
      name: "room",
      component: Dashboard,
      children: [
        {
          path: "/food-category",
          name: "AddFoodCategory",
          component: FoodCategory,
          meta: {
            permission: ["Product Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Food",
                disabled: true,
                to: "food-category",
                exact: true,
              },
            ],
          },
        },
        {
          path: "add",
          name: "AddRoom",
          component: RoomAdd,
          meta: {
            permission: ["Room Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Addroom",
                disabled: false,
                to: "/room",
                text: "Rooms",
                disabled: false,
                to: "/room",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/room/add",
                to: "/room/add",
                exact: true,
              },
            ],
          },
        },

        // {
        //   path: ":id",
        //   name: "View",
        //   component: ProductView,
        //   beforeEnter: (to, from, next) => {
        //     checkPermission(to, from, next);
        //   },
        //   meta: {
        //     permission: ["Product Show"],
        //     breadcrumb: [
        //       {
        //         text: "Dashboard",
        //         disabled: false,
        //         to: "/",
        //         exact: true,
        //       },
        //       {
        //         text: "Products",
        //         disabled: false,
        //         to: "/product",
        //         exact: true,
        //       },
        //       {
        //         text: ":id",
        //         disabled: false,
        //         to: (route) => `${route.param}`,
        //         exact: true,
        //       },
        //       {
        //         text: "View",
        //         disabled: false,
        //         exact: true,
        //       },
        //     ],
        //   },
        // },
      ],
    },
    {
      path: "/room-type/",
      name: "RoomType",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "RoomType",
          component: RoomTypeList,
          meta: {
            permission: ["Room Type Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "RoomType",
                disabled: false,
                to: "/room-type",
                exact: true,
              },
            ],
          },
        },
        {
          path: "add",
          name: "CreateRoomType",
          component: RoomTypeAdd,
          meta: {
            permission: ["Room Type Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "RoomTypes",
                disabled: false,
                to: "/room-type",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/room-type/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: ":id",
          name: "View",
          component: RoomTypeView,
          meta: {
            permission: ["Room Type Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Products",
                disabled: false,
                to: "/room-type",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `${route.param}`,
                exact: true,
              },
              // {
              //   text: "View",
              //   disabled: false,
              //   exact: true,
              // },
            ],
          },
        },
        {
          path: "edit/:id",
          name: "Edit",
          component: RoomTypeEdit,
          meta: {
            permission: ["Room Type Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Products",
                disabled: false,
                to: "/room-type",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `product/${route.param}`,
                exact: true,
              },
              // {
              //   text: "Edit",
              //   disabled: true,
              //   to: "Edit",
              //   exact: true,
              // },
            ],
          },
        },
      ],
    },
    {
      path: "/floor/",
      name: "Floor ",

      component: Dashboard,
      children: [
        {
          path: "/floor",
          name: "AddFloors",
          component: Floor,
          meta: {
            permission: ["Floor Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Floor",
                disabled: true,
                to: "",
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/amenties/",
      name: "Amenties ",

      component: Dashboard,
      children: [
        {
          path: "/amenties",
          name: "AddAmenties",
          component: Amenties,
          meta: {
            permission: ["Amenity Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Amenties",
                disabled: true,
                to: "",
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/places/",
      name: "Places ",

      component: Dashboard,
      children: [
        {
          path: "/places",
          name: "Addplaces",
          component: Places,
          meta: {
            permission: ["Place Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Places",
                disabled: true,
                to: "",
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/kitchens/",
      name: "Kitchens ",

      component: Dashboard,
      children: [
        {
          path: "/kitchens",
          name: "places",
          component: Kitchens,
          meta: {
            permission: ["Kitchen Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Kitchen",
                disabled: true,
                to: "",
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/ingredient/",
      name: "ingredientList ",

      component: Dashboard,
      children: [
        {
          path: "/ingredient",
          name: "Addingredient",
          component: Ingredients,
          meta: {
            permission: ["Place Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Ingredient",
                disabled: true,
                to: "/ingredients",
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/waiter/",
      name: "Waiter",

      component: Dashboard,
      children: [
        {
          path: "/waiter",
          name: "waiter",
          component: Waiter,
          meta: {
            permission: ["Waiter Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Waiter",
                disabled: true,
                to: "",
                exact: true,
              },
            ],
          },
        },
        {
          path: "/waiter/add",
          name: "Addwaiter",
          component: Waiteradd,
          meta: {
            permission: ["Waiter Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Waiter",
                disabled: false,
                to: "/waiter",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/waiter/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: "edit/:id",
          name: "EditWaiter",
          component: WaiterEdit,
          meta: {
            permission: ["Waiter Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Waiter",
                disabled: false,
                to: "/waiter",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `waiter/${route.param}`,
                exact: true,
              },
            ],
          },
        },
        {
          path: ":id",
          name: "ViewWaiter",
          component: WaiterDetails,
          meta: {
            permission: ["Waiter Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Waiter",
                disabled: false,
                to: "/waiter",
                exact: true,
              },

              {
                text: ":id",
                disabled: false,
                to: (route) => `waiter/${route.param}`,
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/waiter/",
      name: "Waiter",

      component: Dashboard,
      children: [
        {
          path: "/kitchen-stocks",
          name: "kitchen-stocks",
          component: KitchenStocks,
          meta: {
            permission: ["Kitchen Stock Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Kitchen-Stocks",
                disabled: true,
                to: "",
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/rate-type/",
      name: "RateType",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "RateType",
          component: RateTypeList,
          meta: {
            permission: ["Rate Type Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "RateType",
                disabled: false,
                to: "/rate-type",
                exact: true,
              },
            ],
          },
        },
        {
          path: "add",
          name: "CreateRateType",
          component: RateTypeAdd,
          meta: {
            permission: ["Rate Type Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "RateTypes",
                disabled: false,
                to: "/rate-type",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/rate-type/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: ":id",
          name: "View",
          component: RateTypeView,
          meta: {
            permission: ["Rate Type Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Products",
                disabled: false,
                to: "/rate-type",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `${route.param}`,
                exact: true,
              },
              {
                text: "View",
                disabled: false,
                exact: true,
              },
            ],
          },
        },
        {
          path: "edit/:id",
          name: "Edit",
          component: RateTypeEdit,
          meta: {
            permission: ["Rate Type Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Products",
                disabled: false,
                to: "/rate-type",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `product/${route.param}`,
                exact: true,
              },
              // {
              //   text: "Edit",
              //   disabled: true,
              //   to: "Edit",
              //   exact: true,
              // },
            ],
          },
        },
      ],
    },
    {
      path: "/room/",
      name: "Room",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "Room",
          component: RoomList,
          meta: {
            permission: ["Room Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Rooms",
                disabled: false,
                to: "/room",
                exact: true,
              },
            ],
          },
        },
        {
          path: "add",
          name: "AddRoom",
          component: RoomAdd,
          meta: {
            permission: ["Room Create"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Rooms",
                disabled: false,
                to: "/room",
                exact: true,
              },
              {
                text: "Create",
                disabled: false,
                to: "/room/add",
                exact: true,
              },
            ],
          },
        },
        {
          path: ":id",
          name: "ViewRoom",
          component: RoomView,
          meta: {
            permission: ["Room Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Rooms",
                disabled: false,
                to: "/room",
                exact: true,
              },
              // {
              //   text: ":id",
              //   disabled: false,
              //   to: (route) => `room/${route.param}`,
              //   exact: true,
              // },
              {
                text: "view",
                disabled: true,
                to: "view",
                exact: true,
              },
            ],
          },
        },
        {
          path: "edit/:id",
          name: "Edit",
          component: RoomEdit,
          meta: {
            permission: ["Room Edit"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Rooms",
                disabled: false,
                to: "/room",
                exact: true,
              },
              {
                text: ":id",
                disabled: false,
                to: (route) => `room/${route.param}`,
                exact: true,
              },
              // {
              //   text: "Edit",
              //   disabled: true,
              //   to: "Edit",
              //   exact: true,
              // },
            ],
          },
        },
      ],
    },
    {
      path: "/reservation/",
      name: "Reservation",
      component: Dashboard,
      children: [
        {
          path: "",
          name: "Room",
          component: ReservationList,
          meta: {
            permission: ["Reservation Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Reservation",
                disabled: false,
                to: "/reservation",
                exact: true,
              },
            ],
          },
        },
        {
          path: ":id",
          name: "ViewReseravtion",
          component: ReservationDetails,
          meta: {
            permission: ["Room Show"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Reservation",
                disabled: false,
                to: "/reservation",
                exact: true,
              },

              {
                text: "view",
                disabled: true,
                to: "view",
                exact: true,
              },
            ],
          },
        },
      ],
    },
    {
      path: "/",
      name: "Reports",
      component: Dashboard,
      children: [
        {
          path: "sales-report",
          name: "SalesReport",
          component: SalesReports,
          beforeEnter: (to, from, next) => {
            checkPermission(to, from, next);
          },
          meta: {
            permission: ["Sales Report Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Report",
                disabled: true,
                to: "/product-report",
                exact: true,
              },
              {
                text: "Sales Report",
                disabled: false,
                to: "/sales",
                exact: true,
              },
            ],
          },
        },
        {
          path: "out-of-stock-report",
          name: "OutOfStockReport",
          component: OutofStockReportComponent,
          beforeEnter: (to, from, next) => {
            checkPermission(to, from, next);
          },
          meta: {
            permission: ["Out Of Stocks Report Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Report",
                disabled: true,
                to: "/out-of-stock-report",
                exact: true,
              },
              {
                text: "Out of Stock Report",
                disabled: false,
                to: "/out-of-stock-report",
                exact: true,
              },
            ],
          },
        },
        {
          path: "low-stock-report",
          name: "Low-Stock-Report",
          component: LowStockReportComponent,
          beforeEnter: (to, from, next) => {
            checkPermission(to, from, next);
          },
          meta: {
            permission: ["Low Stocks Report Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Report",
                disabled: true,
                to: "/low-stock-report",
                exact: true,
              },
              {
                text: "Low Stock Report",
                disabled: false,
                to: "/low-stock-report",
                exact: true,
              },
            ],
          },
        },
        {
          path: "product-report",
          name: "Productreport",
          component: ProductReports,
          beforeEnter: (to, from, next) => {
            checkPermission(to, from, next);
          },
          meta: {
            permission: ["Product Report Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Product Report",
                disabled: false,
                to: "/product-report",
                exact: true,
              },
            ],
          },
        },
        {
          path: "product-list",
          name: "product-list",
          component: ProductAllReport,
          meta: {
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Stocks",
                disabled: false,
                to: "/product-list",
                exact: true,
              },
            ],
          },
        },
        {
          path: "summary",
          name: "summary",
          component: SummaryAllReport,
          meta: {
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Summary",
                disabled: false,
                to: "/summary",
                exact: true,
              },
            ],
          },
        },

        {
          path: "expired-product-list",
          name: "product-list",
          component: ExpiredProducts,
          meta: {
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Expired Stocks",
                disabled: false,
                to: "/expired-product-list",
                exact: true,
              },
            ],
          },
        },

        {
          path: "damaged-product-list",
          name: "product-list",
          component: DamagedProducts,
          meta: {
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Damaged Stocks",
                disabled: false,
                to: "/damaged-product-list",
                exact: true,
              },
            ],
          },
        },
        {
          path: "purchase-return-report",
          name: "PurchaseReturnReport",
          component: PurchaseReturnReports,
          beforeEnter: (to, from, next) => {
            checkPermission(to, from, next);
          },
          meta: {
            permission: ["PurchaseReturn Report Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Purchase Return Report",
                disabled: false,
                to: "/purchase-return-report",
                exact: true,
              },
            ],
          },
        },
        {
          path: "purchase-report",
          name: "PurchaseReport",
          component: PurchaseReports,
          beforeEnter: (to, from, next) => {
            checkPermission(to, from, next);
          },
          meta: {
            permission: ["Purchase Report Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Purchase Report",
                disabled: true,
                to: "/Purchase-Report",
                exact: true,
              },
            ],
          },
        },
        {
          path: "kitchen-stock-report",
          name: "kitchenstockreport",
          component: KitchenStocksReport,
          beforeEnter: (to, from, next) => {
            checkPermission(to, from, next);
          },
          meta: {
            permission: ["Product Report Index", "PurchaseReturn Report Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Kitchen Stock Report",
                disabled: false,
                to: "/kitchen-stock-report",
                exact: true,
              },
            ],
          },
        },
        {
          path: "order-report",
          name: "orderreport",
          component: OrderReport,
          beforeEnter: (to, from, next) => {
            checkPermission(to, from, next);
          },
          meta: {
            permission: ["Order Report Index", "PurchaseReturn Report Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Food Orders Report",
                disabled: false,
                to: "/order-report",
                exact: true,
              },
            ],
          },
        },
        {
          path: "reservation-report",
          name: "reservationreport",
          component: ReservationReport,
          beforeEnter: (to, from, next) => {
            checkPermission(to, from, next);
          },
          meta: {
            permission: ["Reservation Report Index", "PurchaseReturn Report Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Reservations Report",
                disabled: false,
                to: "/reservation-report",
                exact: true,
              },
            ],
          },
        },
        {
          path: "accounting-report",
          name: "accountingreport",
          component: AccountingReport,
          beforeEnter: (to, from, next) => {
            checkPermission(to, from, next);
          },
          meta: {
            permission: ["Accounting Dashboard", "Accounting Report Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Accounting Report",
                disabled: false,
                to: "/accounting-report",
                exact: true,
              },
            ],
          },
        },
        {
          path: "order-food-product",
          name: "orderfoodproductreport",
          component: OrderFoodProductReport,
          beforeEnter: (to, from, next) => {
            checkPermission(to, from, next);
          },
          meta: {
            permission: ["Reservation Report Index", "PurchaseReturn Report Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },

              {
                text: "Order Food & Product Report",
                disabled: false,
                to: "/order-food-product",
                exact: true,
              },
            ],
          },
        },
        {
          path: "purchase-order-report",
          name: "PurchaseOrderReport",
          component: PurchaseOrderReports,
          beforeEnter: (to, from, next) => {
            checkPermission(to, from, next);
          },
          meta: {
            permission: ["PurchaseOrder Report Index"],
            breadcrumb: [
              {
                text: "Dashboard",
                disabled: false,
                to: "/",
                exact: true,
              },
              {
                text: "Purchase Order Report",
                disabled: true,
                to: "/Purchase-Order-Report",
                exact: true,
              },
            ],
          },
        },
      ],
    },
  ];
}

export default router;
